import axios from 'axios'
import toGeoJSON from "@mapbox/togeojson/togeojson.js";
import * as turf from "@turf/turf";
const parcours = {
    namespaced: true,
    state: {
        list: [],
    },
    mutations: {
        setParcours(state, p) {
            state.list = p;
        },
    },
    getters: {
        list(state) {
            return state.list;
        },
        isListEmpty(state) {
            if (!state.list) {
                return true;
            }
            return state.list.length == 0;
        }
    },
    actions: {
        async fetchList({ rootState, dispatch, commit }) {
            if (!rootState.module) {
                return;
            }
            let subfolder = "/";
            if (rootState.module.nm == '1') {
                subfolder = "/nm/";
            }
            let response = await axios.get(rootState.base_url + subfolder + "parcours/get.php?id=" + rootState.module.id + "&base=" + rootState.module.base);
            if (response.data) {
                commit('setParcours', response.data);
                await dispatch('assignDistanceAPlat');
            }


        },
        async assignDistanceAPlat({ state, dispatch, commit }) {

            for (let i = 0; i < state.list.length; i++) {
                const parcours = state.list[i];
                if (!parcours.id || parcours.trace == '' || !parcours.trace.endsWith('.gpx') || parcours.list_points.length == 0) {
                    continue;
                }
                let need_to_compute_arrivee = !parcours.distance_a_plat || parcours.distance_a_plat == 0;
                let need_to_compute = false;
                for (let j = 0; j < parcours.list_points.length; j++) {
                    if (!parcours.list_points[j].distance_a_plat || parcours.list_points[j].distance_a_plat == 0) {

                        need_to_compute = true;
                        break;
                    }
                }

                if (!need_to_compute && !need_to_compute_arrivee) {
                    continue;
                }

                let response = await axios.get("https://sportips.fr/live/" + parcours.trace);
                if (response.data) {
                    var geojson = toGeoJSON.gpx(new DOMParser().parseFromString(response.data, "text/xml"));
                    const lines = geojson.features[0].geometry.coordinates;
                    for (let j = 0; j < parcours.list_points.length; j++) {
                        let elevations = get_elevation_gain_at_a_point(lines, parcours.list_points[j].distance_depuis_depart);
                        const distance_point = parseFloat(parcours.list_points[j].distance_depuis_depart);
                        let kp = distance_point + (0.008 * elevations[0]) - (0.001 * elevations[1]);
                        kp = parseFloat(kp.toFixed(2));
                        dispatch('updateDistanceAPlat', { id: parcours.list_points[j].id, distance_a_plat: kp });
                    }
                    if (need_to_compute_arrivee) {
                        let elevations = get_elevation_gain_at_a_point(lines, parcours.nb_km);
                        const distance_point = parseFloat(parcours.nb_km);
                        let kp = distance_point + (0.008 * elevations[0]) - (0.001 * elevations[1]);
                        kp = parseFloat(kp.toFixed(2));
                        dispatch('updateDistanceAPlatParcours', { id: parcours.id, distance_a_plat: kp });
                    }
                }
            }
        },

        async updateDistanceAPlat({ rootState }, { id, distance_a_plat }) {
            await axios.post(rootState.base_url + "/point/update_distance_a_plat.php", { id: id, distance_a_plat: distance_a_plat });
        },
        async updateDistanceAPlatParcours({ rootState }, { id, distance_a_plat }) {
            await axios.post(rootState.base_url + "/parcours/update_distance_a_plat.php", { id: id, distance_a_plat: distance_a_plat });
        },
    }
}

export default parcours;


function get_elevation_gain_at_a_point(lines, distance_point) {
    if (distance_point == 0) {
        return [0, 0];
    }
    let line = turf.lineString(lines);
    let options = { units: "kilometers" };
    let end_distance = parseFloat(distance_point);
    let line_between_point = turf.lineSliceAlong(line, 0, end_distance, options);
    let d_plus = 0;
    let d_minus = 0;
    let previousElevation = null;
    line_between_point.geometry.coordinates.forEach((point) => {
        if (point.length > 2) {
            let currentElevation = point[2]; // Assuming the third element is elevation
            if (previousElevation !== null) {
                if (currentElevation < previousElevation) {
                    d_minus += previousElevation - currentElevation;
                }
                if (currentElevation > previousElevation) {
                    d_plus += currentElevation - previousElevation;
                }
            }
            previousElevation = currentElevation;
        }
    });
    return [d_plus, d_minus];
}